import { useState, useMemo } from 'react';
import { Users } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import type { Block, TeamBlockContent } from '@/types';
import { TeamMembersEditor } from './TeamPageEditor';

interface TeamEditorPopoverProps {
  block: Block;
  onUpdate: (patch: Partial<Block>) => void;
}

export default function TeamEditorPopover({ block, onUpdate }: TeamEditorPopoverProps) {
  const content = useMemo(() => (block.content ?? {}) as TeamBlockContent, [block.content]);
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className="team-editor-trigger absolute top-3 left-3 z-20 flex items-center gap-1.5 rounded-md bg-white/90 px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm border border-gray-200 hover:bg-white transition-colors"
          onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        >
          <Users className="h-3.5 w-3.5" />
          Team bewerken
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="quote-editor-shell w-[420px] max-h-[var(--radix-popover-content-available-height)] overflow-y-auto p-4"
        side="right"
        align="start"
        sideOffset={8}
        collisionPadding={16}
        onPointerDownOutside={(e) => e.stopPropagation()}
        onInteractOutside={(e) => e.stopPropagation()}
      >
        <TeamMembersEditor content={content} onChange={(next) => onUpdate({ content: next })} />
      </PopoverContent>
    </Popover>
  );
}
